import styled from 'styled-components';

export const ContainerPOS = styled.section`
  width: 100%;
  height: 100%;
  padding: 1.25rem;

  .act-buttons {
    margin-top: 0.9375rem;
    width: 99.2%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .content-show {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    min-width: 0;

    .act-button-marcar-desmarcar-todos {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 0.5rem;
      color: #6307a3;
      min-width: 0;

      button {
        border: none;
        background-color: transparent;
        color: #6307a3;
        font-size: 1rem;
        line-height: 1;
        padding: 0.25rem 0.5rem;

        &:disabled {
          cursor: not-allowed;
          opacity: 0.6;
        }
      }
    }

    .btn-transferir {
      display: flex;
      width: 100%;
      justify-content: flex-end;
      align-items: center;
      min-width: 0;
    }
  }

  @media (max-width: 959.98px) {
    padding: 0.75rem;

    .content-show {
      gap: 0.75rem;
    }

    .act-buttons {
      gap: 0.375rem;
    }

    .content-show .act-button-marcar-desmarcar-todos button {
      font-size: 0.95rem;
      padding: 0.25rem 0.375rem;
    }
  }

  @media (min-width: 1280px) {
    .content-show {
      gap: 1.5rem;
    }
  }
`;
